<template>
	<div class="wrapper-date-item" @click="toggleHoliday">
		<div class="date" v-if="data.date">{{ data.date }}일</div>

		<div class="actions" v-if="data.date">
			<div class="btn btn-e24" @click.stop="toggleE24Holiday()" :class="{active:e24Holiday}">
				<span class="text">E24입고휴무</span>
			</div>

			<div
				class="btn btn-e24-delivery"
				@click.stop="toggleE24DeliveryHoliday()"
				:class="{active:e24DeliveryHoliday}"
			>
				<span class="text">E24배송휴무</span>
			</div>

			<div class="btn btn-wp" @click.stop="toggleWpHoliday()" :class="{active:wpHoliday}">
				<span class="text">WP입고휴무</span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "DateItem",
	props: {
		data: {
			type: Object,
			isRequired: true
		},
		tempHolidayList: {
			type: Object,
			isRequired: false
		}
	},
	data() {
		return {
			holidaySelected: {
				e24Holiday: false,
				e24DeliveryHoliday: false,
				wpHoliday: false
			}
		};
	},
	mounted() {
		this.holidaySelected = {
			e24Holiday: this.e24Holiday,
			e24DeliveryHoliday: this.e24DeliveryHoliday,
			wpHoliday: this.wpHoliday
		};
	},
	computed: {
		e24Holiday() {
			for (let i = 0; this.tempHolidayList.e24Holiday.length > i; i += 1) {
				if (this.tempHolidayList.e24Holiday[i] === this.data.fullDate) {
					return true;
				}
			}
			return false;
		},
		wpHoliday() {
			for (let i = 0; this.tempHolidayList.wpHoliday.length > i; i += 1) {
				if (this.tempHolidayList.wpHoliday[i] === this.data.fullDate) {
					return true;
				}
			}
			return false;
		},
		e24DeliveryHoliday() {
			for (
				let i = 0;
				this.tempHolidayList.e24DeliveryHoliday.length > i;
				i += 1
			) {
				if (this.tempHolidayList.e24DeliveryHoliday[i] === this.data.fullDate) {
					return true;
				}
			}
			return false;
		}
	},
	methods: {
		toggleE24Holiday() {
			const value = !this.holidaySelected.e24Holiday;
			this.holidaySelected.e24Holiday = value;

			const result = {
				value,
				type: "e24",
				fullDate: this.data.fullDate
			};

			this.$emit("setHoliday", result);
		},
		toggleWpHoliday() {
			const value = !this.holidaySelected.wpHoliday;
			this.holidaySelected.wpHoliday = value;

			const result = {
				value,
				type: "wp",
				fullDate: this.data.fullDate
			};

			this.$emit("setHoliday", result);
		},
		toggleE24DeliveryHoliday() {
			const value = !this.holidaySelected.e24DeliveryHoliday;
			this.holidaySelected.e24DeliveryHoliday = value;

			const result = {
				value,
				type: "e24_delivery",
				fullDate: this.data.fullDate
			};

			this.$emit("setHoliday", result);
		},
		toggleHoliday() {
			if (this.data.fullDate) {
				if (
					this.holidaySelected.wpHoliday === false ||
					this.holidaySelected.e24Holiday === false ||
					this.holidaySelected.e24DeliveryHoliday === false
				) {
					this.holidaySelected = {
						e24Holiday: true,
						e24DeliveryHoliday: true,
						wpHoliday: true
					};

					const value = true;
					const result = {
						value,
						type: "all",
						fullDate: this.data.fullDate
					};

					this.$emit("setHoliday", result);
				} else {
					this.holidaySelected = {
						e24Holiday: false,
						e24DeliveryHoliday: false,
						wpHoliday: false
					};

					const value = false;
					const result = {
						value,
						type: "all",
						fullDate: this.data.fullDate
					};

					this.$emit("setHoliday", result);
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.wrapper-date-item {
	width: calc(100% / 7);
	height: auto;
	text-align: left;
	padding: 8px;
	border-radius: 8px;
	transition: all 0.3s;
	cursor: pointer;
	&:hover {
		background-color: #f6f6f6;
	}
	.date {
		font-size: 14px;
		color: #444444;
		font-weight: 700;
		padding: 4px;

		white-space: nowrap;
	}
	.actions {
		padding: 4px 0;

		.btn {
			display: flex;
			justify-content: center;
			align-content: center;
			align-items: center;

			margin: 4px 0;
			padding: 8px 16px;
			border-radius: 36px;
			background-color: #eeeeee;
			transition: all 0.3s;
			cursor: pointer;
			color: #999999;
			// font-weight: 700;

			&.btn-wp.active {
				background-color: #8b6954;
				color: #ffffff;
			}
			&.btn-e24.active {
				background-color: #ffbb00;
				color: #ffffff;
			}
			&.btn-e24-delivery.active {
				background: linear-gradient(to right, #ffbb00 50%, #ff9900 50%);
				color: #ffffff;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/holiday/calendar/components/DateItem.vue